// extracted by mini-css-extract-plugin
export default {"no-data-cloud-invoice":"Edit_no-data-cloud-invoice__bo+40","table-height-adjustment":"Edit_table-height-adjustment__3egl8"};